<template>
  <v-menu
    v-model="openNotifications"
    :close-on-content-click="false"
    max-width="400px"
    nudge-left="345"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :content="unreadCount"
        :color="unreadCount == 0 ? '' : 'green'"
        class="mr-4"
        top
        overlap
      >
        <span>
          <v-btn
            text
            fab
            small
            v-on="on"
            v-bind="attrs"
            :class="openNotifications ? 'text-primary' : ''"
          >
            <v-icon :color="openNotifications ? 'accent' : 'accent darken-3'">{{
              openNotifications ? "mdi-bell-ring" : "mdi-bell"
            }}</v-icon>
          </v-btn>
        </span>
      </v-badge>
    </template>
    <v-card width="400px" elevation="0">
      <v-card-title
        class="pt-4 pb-2 text-primary body-1 d-flex justify-space-between"
      >
        <span>Notifications</span>
        <v-btn
          :disabled="userNotifications.length <= 0"
          small
          text
          depressed
          class="secondary--text"
          @click="markAllAsRead"
          >Clear All</v-btn
        >
      </v-card-title>
      <v-card-text
        elevation-0
        style="max-height: 350px"
        class="pa-0 overflow-y-auto overflow-x-hidden"
        @scroll="handleScroll()"
        ref="notificationParent"
      >
        <div
          v-if="
            userNotifications &&
            userNotifications.length == 0 &&
            !noNewNotifications
          "
          class="d-flex justify-center py-2"
        >
          <v-progress-circular
            :width="3"
            color="grey"
            indeterminate
          ></v-progress-circular>
        </div>
        <div v-else-if="noNewNotifications" class="d-flex justify-center py-2">
          <span>No new Notifications!</span>
        </div>
        <div v-else v-for="(noti, i) in userNotifications" :key="i">
          <v-card
            v-if="!noti.is_read"
            class="pl-4 pa-2 my-1"
            flat
            @click="
              noti.notification_category != 'customer' || redirectIfNeeded(noti)
            "
          >
            <v-row>
              <v-col cols="12" class="pa-0 ma-0">
                <hr style="opacity: 0.4" />
              </v-col>
              <v-col cols="2" class="d-flex align-center justify-center">
                <div
                  style="
                    display: flex;
                    justiy-cotent: center;
                    align-items: center;
                    padding: 15px;
                  "
                  :class="[
                    noti.notification_type == 'success' ? 'successMessage' : '',
                    noti.notification_type == 'warning' ? 'warningMessage' : '',
                    noti.notification_type == 'info' ? 'infoMessage' : '',
                    noti.notification_type == 'error' ? 'errorMessage' : '',
                  ]"
                >
                  <v-icon
                    color="white"
                    v-if="noti.notification_category == 'driver'"
                    >mdi-card-account-details-outline</v-icon
                  >
                  <v-icon
                    color="white"
                    v-else-if="noti.notification_category == 'order'"
                    >mdi-archive-outline</v-icon
                  >
                  <v-icon
                    color="white"
                    v-else-if="noti.notification_category == 'trip'"
                    >mdi-truck-fast</v-icon
                  >
                  <v-icon
                    color="white"
                    v-else-if="noti.notification_category == 'trip_planning'"
                    >mdi-map-marker-distance</v-icon
                  >
                  <v-icon
                    color="white"
                    v-else-if="noti.notification_category == 'location'"
                    >mdi-map-marker</v-icon
                  >
                  <v-icon
                    color="white"
                    v-else-if="noti.notification_category == 'customer'"
                    >mdi-account</v-icon
                  >
                  <v-icon
                    color="white"
                    v-else-if="noti.notification_category == 'vehicle'"
                    >mdi-truck</v-icon
                  >
                  <v-icon
                    color="white"
                    v-else-if="noti.notification_category == 'report'"
                    >mdi-chart-areaspline</v-icon
                  >
                  <v-icon
                    color="white"
                    v-else-if="noti.notification_category == 'user'"
                    >mdi-account-check</v-icon
                  >
                </div>
              </v-col>
              <v-col cols="8" class="d-flex align-center">
                <v-row no-gutters>
                  <v-col cols="12" class="text-body-2">
                    <span>
                      {{ noti.title }}
                    </span>
                  </v-col>
                  <v-col cols="12" class="text-caption">
                    {{ noti.message }}
                  </v-col>
                  <v-col cols="12" class="text-caption font-weight-bold mt-1">
                    {{ noti.created }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="2" class="d-flex align-center">
                <v-btn
                  small
                  icon
                  @click="markAsRead(noti.id)"
                  class="primary--text"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { bus } from "@/main";

export default {
  props: {
    value: {
      type: Boolean,
      require: true,
      default: false,
    },
  },
  data() {
    return {
      notiInterval: null,
      limit: 10,
      unreadCount: 0,
      noNewNotifications: false,
      userNotifications: [],
      totalCount: null,
    };
  },
  computed: {
    openNotifications: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.getUserNotificationList(true);
      }
    },
  },
  methods: {
    getNewNotification(data) {
      this.noNewNotifications = false;
      this.userNotifications.push(data);
    },
    redirectIfNeeded(notification) {
      if (notification.title == "Customer Address Update Request") {
        this.$router.push({
          name: "customer-location-update-list",
          query: notification.notification_context,
        });
        this.markAsRead(notification.id);
        this.openNotifications = false;
      }
    },
    handleScroll() {
      let elem = this.$refs.notificationParent;
      if (elem == null) {
        return false;
      } else if (
        Math.ceil(elem.offsetHeight + elem.scrollTop) == elem.scrollHeight
      ) {
        this.getUserNotificationList(false);
      }
    },
    getUserNotificationList(reload) {
      this.noNewNotifications = false;
      let params;
      if (!reload) {
        params = { offset: this.userNotifications.length };
      } else {
        params = { offset: 0 };
      }
      if (reload || this.totalCount != this.userNotifications.length) {
        this.$api.userNotification
          .getUserNotificationList(params)
          .then((result) => {
            if (result.count == 0 && result.data.length == 0) {
              this.noNewNotifications = true;
            } else {
              this.getNotificationCount();
              if (!reload) {
                this.userNotifications = [
                  ...this.userNotifications,
                  ...result.data,
                ];
              } else {
                this.userNotifications = result.data;
                this.totalCount = result.count;
              }
            }
          })
          .catch((err) => {
            if (err.message) {
              bus.$emit("showToastMessage", {
                message: err.message,
                color: "error",
              });
            } else {
              bus.$emit("showToastMessage", {
                message: "Error Fetching data!",
                color: "error",
              });
            }
          });
      }
    },
    getNotificationCount() {
      this.$api.userNotification
        .getNotificationCount()
        .then((res) => {
          this.unreadCount = res?.data?.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    markAllAsRead() {
      let ids = this.userNotifications.map((notification) => {
        return notification.id;
      });
      let payload = {
        id: ids,
      };
      this.$api.userNotification
        .markAsSeenUserNotification(payload)
        .then(() => {
          this.openNotifications = false;
          this.getUserNotificationList(true);
          this.getNotificationCount();
        })
        .catch((err) => {
          if (err.message) {
            bus.$emit("showToastMessage", {
              message: err.message,
              color: "error",
            });
          } else {
            bus.$emit("showToastMessage", {
              message: "Error Fetching data!",
              color: "error",
            });
          }
        });
    },
    removeMarkAsReadNotification(id) {
      if (this.userNotifications.find((v) => v.id == id)) {
        this.userNotifications.splice(
          this.userNotifications.find((v) => v.id == id),
          1
        );
        this.getUserNotificationList(true);
      }
    },
    markAsRead(id) {
      let payload = {
        id: [id],
      };
      this.$api.userNotification
        .markAsSeenUserNotification(payload)
        .then(() => {
          this.removeMarkAsReadNotification(id);
          this.getNotificationCount();
          if (this.userNotifications && this.userNotifications.length == 0) {
            this.openNotifications = true;
          }
        })
        .catch((err) => {
          if (err.message) {
            bus.$emit("showToastMessage", {
              message: err.message,
              color: "error",
            });
          } else {
            bus.$emit("showToastMessage", {
              message: "Error Fetching data!",
              color: "error",
            });
          }
        });
    },
  },
  mounted() {
    this.getUserNotificationList(true);
    this.notiInterval = setInterval(() => {
      this.getUserNotificationList(true);
    }, 60000);
  },
  created() {
    bus.$on("getNotification", this.getNewNotification);
  },
  beforeDestroy() {
    clearInterval(this.notiInterval);
    this.userNotifications = [];
    this.unreadCount = 0;
    this.totalCount = null;
  },
};
</script>

<style scoped>
.successMessage {
  background-color: #d1d3d4;
}
.errorMessage {
  background-color: #ee919d;
}
.warningMessage {
  background-color: #e1af0f;
}
.infoMessage {
  background-color: #6bcadc;
}
</style>
